export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_JOBTITLES: 'SET_JOBTITLES',
    SET_SELECTED_JOBTITLE: 'SET_SELECTED_JOBTITLE',
    ADD_JOBTITLE: 'ADD_JOBTITLE',
    UPDATE_JOBTITLE: 'UPDATE_JOBTITLE',
    DELETE_JOBTITLE: 'DELETE_JOBTITLE',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE'
};

export const initialState = {
    jobTitles: [],
    selectedJobTitle: null,
    loading: false,
    error: null,
    filter: {
        name: null,
        code: null,
        status: null,
        type: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'name',
        direction: 'asc'
    },
    lastUpdated: null
};

export const jobTitleReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_JOBTITLES: {
            // Handle both paginated response and simple array response
            const isArrayResponse = Array.isArray(action.payload);
            const jobTitlesData = isArrayResponse ? action.payload : action.payload.content || [];
            const totalCount = isArrayResponse ? action.payload.length : action.payload.totalElements || 0;
            const currentPage = isArrayResponse ? 0 : action.payload.number || 0;

            return {
                ...state,
                jobTitles: jobTitlesData,
                pagination: {
                    ...state.pagination,
                    total: totalCount,
                    page: currentPage
                },
                lastUpdated: new Date().toISOString(),
                loading: false
            };
        }

        case ACTIONS.SET_SELECTED_JOBTITLE:
            return {
                ...state,
                selectedJobTitle: action.payload,
                loading: false
            };

        case ACTIONS.ADD_JOBTITLE:
            return {
                ...state,
                jobTitles: [action.payload, ...state.jobTitles],
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.UPDATE_JOBTITLE:
            return {
                ...state,
                jobTitles: state.jobTitles.map((jobTitle) => (jobTitle.id === action.payload.id ? action.payload.data : jobTitle)),
                selectedJobTitle: state.selectedJobTitle?.id === action.payload.id ? action.payload.data : state.selectedJobTitle,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.DELETE_JOBTITLE:
            return {
                ...state,
                jobTitles: state.jobTitles.filter((jobTitle) => jobTitle.id !== action.payload),
                selectedJobTitle: state.selectedJobTitle?.id === action.payload ? null : state.selectedJobTitle,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};
